export default function Services() {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Implementação Chave-na-Mão',
      description: 'Implementação completa de consultórios, clínicas, hospitais, unidades de cuidados continuados, laboratórios de genética e clínicas veterinárias'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Procedimentos Legais',
      description: 'Apoio nos primeiros passos e procedimentos legais para a abertura da empresa, incluindo todos os serviços essenciais'
    },
    {
      icon: 'ri-pencil-ruler-2-line',
      title: 'Projetos de Arquitetura',
      description: 'Projetos de execução de arquitetura e de especialidades técnicas de engenharia adaptados às suas necessidades'
    },
    {
      icon: 'ri-team-line',
      title: 'Formação de Equipas',
      description: 'Formação completa das equipas de trabalho e realização de ações de formação junto da equipa'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Elaboração de Plano Financeiro',
      description: 'Desenvolvemos planos financeiros completos para o seu negócio'
    },
    {
      icon: 'ri-palette-line',
      title: 'Criação de Marca',
      description: 'Criação da marca, plano de marketing, desenvolvimento do website e gestão de redes sociais'
    },
    {
      icon: 'ri-global-line',
      title: 'Comunicação Digital',
      description: 'Elaboração de conteúdos para o website e comunicação digital com gestão profissional de redes sociais'
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Suporte Jurídico',
      description: 'Suporte jurídico personalizado e apoio na organização de formações e pequenos eventos'
    }
  ];

  return (
    <section id="servicos" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Nossos Serviços</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Soluções Completas para o Seu Negócio
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Oferecemos uma gama completa de serviços especializados para apoiar o crescimento e sucesso da sua unidade de saúde
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 group cursor-pointer"
            >
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-teal-600 transition-colors">
                <i className={`${service.icon} text-2xl text-teal-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-teal-600 rounded-3xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Modalidade Chave-na-Mão
          </h3>
          <p className="text-lg text-white/90 max-w-3xl mx-auto">
            Oferecemos uma solução completa que inclui todos os serviços essenciais para quem quer iniciar a sua atividade empresarial na área da saúde, desde o planeamento até à implementação final
          </p>
        </div>
      </div>
    </section>
  );
}